import React from 'react'
import Layout from '../components/Layout'
import BottomButton from '../components/BottomButton'
import FAQ from '../components/dashboard/FAQ'

export default function faq() {
  return (
    <div id="faq-page">
      <Layout>
        <FAQ />
        <BottomButton href="/" text="Go Back" />
      </Layout>
    </div>
  )
}
